import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import Seo from "../components/Seo";
import BreadcrumbSchema from "../components/BreadcrumbSchema";
import { STATIC_PAGES, SITE_ORIGIN } from "../seo/openGraph";
import { blogPosts } from "../data/blogPosts";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.08, duration: 0.5, ease: "easeOut" },
  }),
};

export default function BlogIndexPage() {
  const posts = [...blogPosts].sort((a, b) => (a.published < b.published ? 1 : -1));

  return (
    <>
      <Seo {...STATIC_PAGES.blog} />
      <BreadcrumbSchema
        items={[
          { name: "Home", url: SITE_ORIGIN },
          { name: "Blog", url: `${SITE_ORIGIN}/blog` },
        ]}
      />

      <section className="pt-32 pb-24 bg-[#0A0A0A]">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
          <motion.div variants={fadeUp} initial="hidden" animate="visible">
            <p className="text-[#00AEEF] text-sm uppercase tracking-widest font-medium mb-4">From the studio</p>
            <h1 className="text-5xl md:text-6xl font-bold tracking-tight mb-6" data-testid="blog-index-heading">
              Blog.
            </h1>
            <p className="text-lg text-neutral-300 max-w-2xl leading-relaxed">
              Practical notes for founders and product leads shipping a first mobile or web app with a vendor.
            </p>
          </motion.div>

          <div className="mt-16 max-w-3xl space-y-6">
            {posts.map((post, index) => (
              <motion.article
                key={post.path}
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                custom={index}
              >
                <Link
                  to={post.path}
                  className="block bg-[#121212] border border-white/5 rounded-xl p-8 hover:border-[#00AEEF]/40 transition-colors"
                  data-testid={`blog-card-${post.slug}`}
                >
                  <p className="text-xs uppercase tracking-widest text-[#00AEEF] font-medium">{post.publishedLabel}</p>
                  <h2 className="text-2xl md:text-3xl font-bold text-white mt-3 tracking-tight">{post.title}</h2>
                  <p className="text-gray-400 mt-4 leading-relaxed">{post.dek}</p>
                  <span className="inline-flex items-center gap-2 text-[#00AEEF] text-sm font-medium mt-6">
                    Read this post <ArrowRight className="w-4 h-4" />
                  </span>
                </Link>
              </motion.article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
